import dialog from './dialogs';

const subscribe = (store) => {
  dialog.subscriber.subscribe(store);
};

export default {
  subscribe,
};
